import { ChangeDetectionStrategy, Component, inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { LoadingIndicatorService } from '../../shared/services/loading-indicator.service';

@Component({
  selector: 'app-loading-overlay',
  template: `
    @if (isLoading$()) {
      <div class="loading-indicator">
        <mat-spinner></mat-spinner>
      </div>
    }
  `,
  styleUrls: ['./loading-overlay.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingOverlayComponent {
  private readonly loadingIndicatorService: LoadingIndicatorService =
    inject(LoadingIndicatorService);
  public isLoading$: Signal<boolean> = toSignal(this.loadingIndicatorService.getIndicator(), {
    initialValue: false,
  });
}
